
import state from "./moduleUnitTypeState.js"
import mutations from "./moduleUnitTypeMutations.js"
import getters from "./moduleUnitTypeGetters.js"
import actions from './moduleUnitTypeActions.js';
export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
